import {useUserStore} from '~/store/user'
import {USER_RIGHTS_MAPPING} from 'assets/js/constants'

export const useRightsHelper = () => {
  const userHasRight = (right: string) => {
    return useUserStore().rights && useUserStore().rights?.some((item) => item === right)
  }

  const isQuoterUser = computed(() => {
    return userHasRight(USER_RIGHTS_MAPPING.PRODUCT_VIEW_PRICE)
      && userHasRight(USER_RIGHTS_MAPPING.PRODUCT_VIEW_AVAILABILITY)
      && !userHasRight(USER_RIGHTS_MAPPING.PRODUCT_BUY)
      && userHasRight(USER_RIGHTS_MAPPING.PRODUCT_REQUEST)
  })

  const isInfoUser = computed(() => {
    return userHasRight(USER_RIGHTS_MAPPING.PRODUCT_VIEW_PRICE)
      && userHasRight(USER_RIGHTS_MAPPING.PRODUCT_VIEW_AVAILABILITY)
      && !userHasRight(USER_RIGHTS_MAPPING.PRODUCT_BUY)
      && !userHasRight(USER_RIGHTS_MAPPING.PRODUCT_REQUEST)
  })

  return {
    userHasRight,
    isQuoterUser,
    isInfoUser
  }
}
